// extracted by mini-css-extract-plugin
export default {"main":"IdLink_main__CFSB2","button":"IdLink_button__Lj4Xz","wikidata":"IdLink_wikidata__A5wEx","isni":"IdLink_isni__XtS1P","pnd":"IdLink_pnd__hZ6ee"};